import { useSelector } from 'react-redux'
import { formatText } from '../../../../helpers/value'
import { selectDataTable } from '../store/slice'

export const NameScore = ({ rowId }) => {
  const dataRow = useSelector(selectDataTable(rowId))
  return <>{formatText(dataRow.criteriaName)}</>
}
